import { createGlobalStyle } from 'styled-components'

function appHeight() {
  const doc = document.documentElement
  doc.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}

window.addEventListener('resize', appHeight)
appHeight()

export default createGlobalStyle`

    *{
        margin:0;
        padding:0;
    }

    html, body {
        height:100vh
    }

    /* html {
  scrollbar-face-color: #646464;
  scrollbar-base-color: #646464;
  scrollbar-3dlight-color: #646464;
  scrollbar-highlight-color: #646464;
  scrollbar-track-color: #000;
  scrollbar-arrow-color: #000;
  scrollbar-shadow-color: #646464;
}

::-webkit-scrollbar { width: 8px; height: 3px;}
::-webkit-scrollbar-button {  background-color: #666; }
::-webkit-scrollbar-track {  background-color: #646464;}
::-webkit-scrollbar-track-piece { background-color: #000;}
::-webkit-scrollbar-thumb { height: 50px; background-color: #666; border-radius: 3px;}
::-webkit-scrollbar-corner { background-color: #646464;}}
::-webkit-resizer { background-color: #666;} */

    body{
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100 );
        background-color: ${(props) => props.theme.backgroundColor};
    }
    .root{
        height:100%;
        width:100%;
    }
`
